import type React from 'react';
import TooltipV2 from 'app/shared/modules/TooltipV2';
import { getNewUnitBadgeStyles, newUnitBadgeWrapperStyles } from './NewUnitBadge.styles';

interface NewUnitBadgeProps {
  text: string;
  variant?: 'hdp' | 'srp';
  showTooltip?: boolean;
  tooltipContent?: string;
}

const NewUnitBadge: React.FC<NewUnitBadgeProps> = ({ text, variant = 'hdp', showTooltip = false, tooltipContent }) => {
  const badgeContent = (
    <span className={getNewUnitBadgeStyles(variant)} tabIndex={showTooltip ? 0 : undefined}>
      {text}
    </span>
  );

  if (!showTooltip || !tooltipContent) {
    return <div className={newUnitBadgeWrapperStyles}>{badgeContent}</div>;
  }

  return (
    <div className={newUnitBadgeWrapperStyles}>
      <TooltipV2
        content={tooltipContent}
        position="below"
        size="auto"
        positionStrategy="trigger-relative"
        data-testid="new-unit-badge-tooltip"
      >
        {badgeContent}
      </TooltipV2>
    </div>
  );
};

export default NewUnitBadge;
